import { render, staticRenderFns } from "./ReferenciaDetalle.vue?vue&type=template&id=055fcf12&"
import script from "./ReferenciaDetalle.vue?vue&type=script&lang=js&"
export * from "./ReferenciaDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports